import {
  amplitudeKeyInternal,
  amplitudeKeyOldInternal,
  amplitudeKeyOldProd,
  amplitudeKeyProd,
  appTimestamp,
  appVersion,
  arcgisApiKeyDev,
  autodeskApiUrl,
  commitId,
  commitUrl,
  intercomAppIdDev,
  isNumberedEnv,
  jiraTicketId,
  jiraTicketUrl,
  localizeKey,
  muiProKey,
  numberedEnv,
  procoreApiUrlStaging,
  pullRequestId,
  pullRequestUrl,
  sentryDSNKey,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "staging",
  appRegion: "com",
  appEnv: "com-staging",
  urls: {
    apiBaseUrl: "https://core.api.staging.holobuilder.com",
    analyticsBaseUrl: "",
    sphereViewerUrl: "https://viewer.staging.holobuilder.com",
    sphereVaultUrl: "https://vault.staging.holobuilder.com",
    dashboard20Api: "https://sphere.staging.holobuilder.com/api",
    hbWebEditorUrl: "https://app.staging.holobuilder.com",
    progressApiUrl: "https://progress.api.staging.holobuilder.com",
    sphereEntryPageUrl:
      numberedEnv === "dev1"
        ? "https://dev1.entry.staging.holobuilder.com"
        : "https://entry.staging.holobuilder.com",
    adminPanelUrl: "https://admin.staging.holobuilder.com",
    cookieManagerUrl:
      "https://cookies.staging.holobuilder.com/cookie-manager/manager/latest",
    powerBIBaseUrl: "https://hb-powerbi-func-com-staging.azurewebsites.net",
    projectApiUrl: "https://v2.project.api.staging.holobuilder.com",
    hbDashboardUrl: "https://dashboard.staging.holobuilder.com",
    uploadFrontDoorUrl: "https://uploads.staging.holobuilder.com",
    uploadStorageUrl: "https://holobuildercomstaging.blob.core.windows.net",
    activityApiUrl: "https://activity.api.staging.holobuilder.com",
  },
  features: {
    muiProKey,
    localizeKey,
    sentryDSNKey,
    auth0: {
      domain: "login.eu.stg.farosphere.com",
      clientId: "iRaekFL1jv86gIakQI31pbVMwGLEwB5T",
    },
    amplitudeKeyInternal,
    amplitudeKeyProd,
    amplitudeKeyOldInternal,
    amplitudeKeyOldProd,
    intercomAppId: intercomAppIdDev,
    arcgisApiKey: arcgisApiKeyDev,
  },
  integrations: {
    procoreApiUrl: procoreApiUrlStaging,
    autodeskApiUrl,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support+staging@holobuilder.com",
  isNumberedEnv,
  numberedEnv,
};
